import React from 'react'
import Projects from './Components/pages/Projects';
import Contactme from './Components/pages/contactme';
import Home from './Components/pages/Home';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';


function Aminaterouter() {
  const location = useLocation();
  return (
    <AnimatePresence>
      <Routes location={location} key={location.pathname}>
        <Route path='/' exact element={<Home />} />
        <Route path='/projects' element={<Projects />} />
        <Route path='/contact' element={<Contactme />} />
      </Routes>
    </AnimatePresence>
  )
}

export default Aminaterouter